import request from "./request";

//自定义列字段
export const saveCustomColumn = (data) =>
  request("/graspReport/saveCustomColumn", data, "POST");
export const updateCustomColumn = (data) =>
  request("/graspReport/updateCustomColumn", data, "POST");
export const queryCustomColumn = (data) =>
  request("/graspReport/queryCustomColumn", data, "GET");
export const deleteCustomColumn = (data) =>
  request("/graspReport/deleteCustomColumn", data, "POST");

//投放账号
// export const getPros = (data) => request("/pro/getPros", data, "POST");
export const getDesigner = () => request("/tag/getDesigner", null, "GET");
export const queryAdvertiserData = (data) =>
  request("/graspReport/queryAdvertiserData", data, "GET");
export const updateAdvertiserBudget = (data) =>
  request("/graspReport/updateAdvertiserBudget", data, "POST");
//获取广告主账号列表
export const getAdCountList = (data) => request("/bi/getAdvertiserInfo", data, "POST_JSON");

//广告组
export const getAdvertiserInfo = (data) =>
  request("/bi/getAdvertiserInfo", data, "POST_JSON");
export const queryCampaignData = (data) =>
  request("/graspReport/queryCampaignData", data, "GET");
export const updateCampaignStatus = (data) =>
  request("/graspReport/updateCampaignStatus", data, "POST");

//计划
export const queryCampaign = (data) => request("/graspReport/queryCampaign", data, "POST");
export const queryAdSetData = (data) => request("/graspReport/queryAdSetData", data, "GET");
export const updateAdStatus = (data) => request("/graspReport/updateAdStatus", data, "POST");

//创意
export const queryAdSet = (data) => request("/graspReport/queryAdSet", data, "GET");
export const queryAdCreativeData = (data) =>
  request("/graspReport/queryAdCreativeData", data, "GET");
export const updateAdCreativeStatus = (data) =>
  request("/graspReport/updateAdCreativeStatus", data, "POST");

//刷新数据
export const refreshReportData = () =>
  request("/graspReport/refreshReportData", null, "GET");

///////////////////////////////////////////////
///////////////// 快 手 ///////////////////////
///////////////////////////////////////////////
//投放账号
export const queryAdvertiserData_k = (data) =>
  request("/kuaishou/queryAdvertiserData", data, "GET");
//广告组
export const queryAdSetData_k = (data) => request("/kuaishou/queryAdSetData", data, "GET");
//广告计划
export const queryCampaignData_k = (data) =>
  request("/kuaishou/queryCampaignData", data, "GET");
//广告创意
export const queryAdCreativeData_k = (data) =>
  request("/kuaishou/queryAdCreativeData", data, "GET");
//刷新快手数据
export const refreshReportData_k = () => request("/kuaishou/graspReportData", null, "GET");
//修改快手预算
export const updateBudget = (data) => request("/kuaishou/updateBudget", data, "GET");
//修改状态
export const updateState = (data) => request("/kuaishou/updateState", data, "POST_JSON");

// 广点通
// 账户报表
export const queryAdvertiserData_gdt = (data) =>
  request("/tencent/report/accountReport", data, "POST");
//获取广告主账号列表
export const getAdCountList_gdt = (data) =>
  request("/bi/getAdvertiserInfo", data, "POST_JSON");
// 计划报表
export const getCampaignReport = (data) =>
  request("/tencent/report/campaignReport", data, "POST");
// 推广计划列表
export const getCampaignList = (data) =>
  request("/tencent/report/campaignList", data, "POST");
// 批量修改计划状态
export const updateCampaignStatus_gdt = (data) =>
  request("/tencent/campaign/updateCampaignStatus", data, "POST_JSON");
// 批量修改创意状态
export const updateCreateStatus_gdt = (data) =>
  request("/tencent/campaign/updateAdStatus", data, "POST_JSON");
// 批量修改广告状态
export const updateAdGroupStatus_gdt = (data) =>
  request("/tencent/campaign/updateAdGroupStatus", data, "POST_JSON");
// 刷新数据
export const refreshReportData_gdt = (data) =>
  request("/tencent/report/refreshData", data, "POST");
// 广告报表
export const getAdReport_gdt = (data) => request("/tencent/report/adReport", data, "POST");
// 广告列表
export const getAdGroupList = (data) => request("/tencent/report/adGroupList", data, "POST");
// 创意报表
export const getCreativeReport_gdt = (data) =>
  request("/tencent/report/creativeReport", data, "POST");
// 创意列表
export const getAdList_gdt = (data) => request("/tencent/report/adList", data, "POST");

// 头条2.0
// 账号报表
export const getAdvertiserReport = (data) =>
  request("/custom/advertiserReport", data, "POST_JSON");
// 项目报表
export const getProjectReport = (data) =>
  request("/custom/projectReport", data, "POST_JSON");
// 修改项目状态
export const updateProjectStatus = (data) =>
  request("/custom/projectStatus", data, "POST_JSON");
// 广告报表
export const getPromotionReport = (data) =>
  request("/custom/promotionReport", data, "POST_JSON");
// 修改广告状态
export const updatePromotionStatus = (data) =>
  request("/custom/promotionStatus", data, "POST_JSON");
// 项目列表
export const getProjectList = (data) => request("/custom/projectList", data, "POST_JSON");
